import PropTypes from "prop-types"
import { safeDivide } from "helpers/math"

function ChartDefs({ pathId, axisId, offset, chartWidth = 0 }) {
  const gradientsOffset = `${safeDivide(offset, chartWidth) * 100}%`

  return <defs>
    <linearGradient id={pathId} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} className="selected-path-start" />
      <stop offset={gradientsOffset} className="selected-path-end" />
    </linearGradient>
    <linearGradient id={axisId} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} className="selected-axis-start" />
      <stop offset={gradientsOffset} className="selected-axis-end" />
    </linearGradient>
  </defs>
}

ChartDefs.propTypes = {
  pathId: PropTypes.string.isRequired,
  axisId: PropTypes.string.isRequired,
  offset: PropTypes.number,
  chartWidth: PropTypes.number,
}

export default ChartDefs
